import { FIEQueryType } from "./components/fie-queries";
import {
    State,
    GET_AVAILABLE_OPTIONS,
    AvailableOptionsType,
    FindSimilarType,
    DiagnosticsType,
    SET_PRODUCTS_TO_STORE,
    SET_IS_LOADING_PRODUCTS,
    GET_FIE_QUERIES,
    SET_FIE_QUERIES_TO_STORE,
} from "./types"

import {Action, ID, ReduxList} from "app/types/app-types";

export const initialState: ReduxList<any> = {
    data: [],
    isLoaded: false,
    isLoading: false,
    error: null,
    updated: null
}

export const initialFindSimilarState : FindSimilarType = {
    totalRows: null,
    exportedRows: null,
    isExporting: null,
    isExportReady: null,
    isSearching: null,
    csvChecksum: null,
    error: null,
    similarProducts: [],
}

export function productsReducer(state: State = initialState, action): State {
    switch (action.type) {
        case SET_IS_LOADING_PRODUCTS:
            return { ...state, isLoading: action.payload }
        case SET_PRODUCTS_TO_STORE:
            return { ...state, isLoading: false, isLoaded: true, data: action.payload }
        default:
            return state
    }
}

export function fieQueriesReducer(state: State = initialState, action): State {
    switch (action.type) {
        case GET_FIE_QUERIES:
            return { ...state, isLoading: true }
        case SET_FIE_QUERIES_TO_STORE:
            return { ...state, isLoading: false, isLoaded: true, data: action.payload }
        default:
            return state
    }
}

export function activeFIEQueryIdReducer(state: ID = null, action: Action<any>): ID {
    switch (action.type) {
        case SET_ACTIVE_FIE_QUERY:
            return action.payload
        default:
            return state
    }
}

export function availableOptionsReducer(state: State = initialState, action): State {
    switch (action.type) {
        case GET_AVAILABLE_OPTIONS.CREATE:
            return { ...state, isLoading: true }
        case GET_AVAILABLE_OPTIONS.SUCCESS:
            return { ...state, isLoading: false, isLoaded: true, data: action.payload }
        case GET_AVAILABLE_OPTIONS.ERROR:
            return { ...state, isLoading: false, isLoaded: false, error: "error" }
        default:
            return state
    }
}

export function findSimilarReducer(state: FindSimilarType = initialFindSimilarState, action): FindSimilarType {
    switch (action.type) {
        case SET_FIND_SIMILAR:
            return { ...state, ...action.payload}
        default:
            return state
    }
}

// ACTIONS
export function setProductsToStore(data: DiagnosticsType): Action<DiagnosticsType> {
    return {
        type: SET_PRODUCTS_TO_STORE,
        payload: data
    }
}

export function setIsLoadingProducts(isLoading: boolean): Action<boolean> {
    return {
        type: SET_IS_LOADING_PRODUCTS,
        payload: isLoading
    }
}

export function setFIEQueriesToStore(data: FIEQueryType[]): Action<FIEQueryType[]> {
    return {
        type: SET_FIE_QUERIES_TO_STORE,
        payload: data
    }
}

export const getAvailableOptions = () => ({
    type: GET_AVAILABLE_OPTIONS.CREATE,
})

export function setAvailableOptionsToStore(availableOptions: AvailableOptionsType): Action<AvailableOptionsType> {
    return {
        type: GET_AVAILABLE_OPTIONS.SUCCESS,
        payload: availableOptions,
    }
}

export const SET_ACTIVE_FIE_QUERY = 'SET_ACTIVE_FIE_QUERY'
export function setActiveFIEQueryId(activeFieQueryId: ID): Action<ID> {
    return {
        type: SET_ACTIVE_FIE_QUERY,
        payload: activeFieQueryId
    }
}

//VisualSimilarity actions:
export const SET_FIND_SIMILAR = 'SET_FIND_SIMILAR'
export const setFindSimilar = (state: FindSimilarType): Action<FindSimilarType> => ({
    type: SET_FIND_SIMILAR,
    payload: state
})